import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import "react-i18next";
import "@perxis-auto/ui-kit/lib/components/Grid";
import "@perxis-auto/ui-kit/lib/components/Typography";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { Constructor } from "../../../shared/ui/constructor/Constructor.js";
import "@perxis-auto/ui-kit";
import "../../../shared/context/constructor.js";
import "../../../shared/ui/constructorItem/ConstructorItem.js";
import "clsx";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "@perxis-auto/ui-kit/lib/components/Button";
import "@perxis-auto/ui-kit/lib/components/Icon";
import styles from "./VehiclesList.module.scss.js";
const VehiclesList = memo(function VehiclesList2({ layout, widgets, anchorRef, ...props }) {
  return /* @__PURE__ */ jsxs("div", { className: styles.vehiclesList, ...props, children: [
    /* @__PURE__ */ jsx("div", { ref: anchorRef }),
    /* @__PURE__ */ jsx(Constructor, { isSubConstructor: true, layout, widgets })
  ] });
});
export {
  VehiclesList
};
